import { applyTokens } from "../../../utilities/applyTokens.js";
const createStates = (state) => {
    const { default: defaultState, hover, active } = state;
    return Object.assign(Object.assign({}, applyTokens(defaultState)), { "&:not(.Mui-disabled):hover": Object.assign({}, applyTokens(hover)), "&:not(.Mui-disabled):active": Object.assign({}, applyTokens(active)) });
};
const list = (tokens) => {
    const { component: { button, list: { item, sectioned }, }, semantic, core, } = tokens;
    const rightPaddingWithSecondaryAction = (clickable) => ({
        paddingRight: `calc(${clickable ? item.clickable.paddingRight.value : "0px"} + ${button.iconOnly.medium.width.value} + ${item.content.gap.value})`,
    });
    return {
        MuiList: {
            defaultProps: {
                disablePadding: true,
            },
        },
        MuiListItem: {
            defaultProps: {
                // Plain list items have no left and right padding
                disableGutters: true,
                divider: true,
            },
            styleOverrides: {
                root: ({ ownerState }) => (Object.assign(Object.assign({ backgroundColor: item.default.backgroundColor.value, gap: item.content.gap.value, 
                    // Media
                    "& > img:first-of-type": Object.assign({}, applyTokens(item.content.media)) }, (ownerState.secondaryAction && {
                    // and the ListItem is a MuiListItemButton,
                    // we need to add the padding to the button
                    "&:has(> .MuiListItemButton-root) >.MuiListItemButton-root": Object.assign(Object.assign({}, rightPaddingWithSecondaryAction(true)), applyTokens(item.spacing.spacious)),
                    // or if the ListItem is not a MuiListItemButton,
                    // we need to add the padding to the root
                    "&:not(:has(> .MuiListItemButton-root))": Object.assign(Object.assign({}, rightPaddingWithSecondaryAction(true)), applyTokens(item.spacing.spacious)),
                })), (ownerState.disablePadding && {
                    // When users turn off padding on the List Item, we pass the spacing to the button
                    ".MuiListItemButton-root": applyTokens(item.spacing.tight),
                }))),
                padding: ({ ownerState }) => (Object.assign({}, applyTokens(ownerState.disablePadding ? item.spacing.none : item.spacing.spacious))),
                dense: ({ ownerState }) => ({
                    "&&": Object.assign({}, applyTokens(ownerState.disablePadding ? item.spacing.none : item.spacing.tight)),
                }),
                divider: {
                    borderBottom: "none",
                    boxShadow: `inset 0 -${item.borderBottomWidth.value} 0 0 ${item.borderColor.value}`,
                },
            },
        },
        MuiListItemButton: {
            defaultProps: {
                disableGutters: false,
                divider: false,
            },
            styleOverrides: {
                root: Object.assign(Object.assign({}, createStates(item)), { gap: item.content.gap.value, borderBottom: "none", boxShadow: `inset 0 -${item.borderBottomWidth.value} 0 0 ${item.borderColor.value}`, "&.Mui-selected": Object.assign({}, applyTokens(item.selected)), "&:focus": {
                        outlineOffset: "-2px",
                        boxShadow: semantic.shadow.focusInset.value.stringValue,
                    }, "&+.MuiListItemSecondaryAction-root": {
                        right: item.clickable.paddingRight.value,
                    } }),
                gutters: {
                    // clickable list items have left and right padding
                    paddingLeft: item.clickable.paddingLeft.value,
                    paddingRight: item.clickable.paddingRight.value,
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: 0,
                    "&, & > svg": {
                        width: item.content.icon.width.value,
                        height: item.content.icon.height.value,
                    },
                },
            },
        },
        MuiListItemText: {
            styleOverrides: {
                root: Object.assign({ marginTop: 0, marginBottom: 0 }, applyTokens(item.content.label.default)),
                multiline: {
                    display: "flex",
                    flexDirection: "column",
                    gap: `${core.spacing["0_5"].value}`,
                    // When text is multi-line, we treat the primary text as a title
                    ".MuiListItemText-primary": applyTokens(item.content.label.title),
                },
                primary: Object.assign({}, applyTokens(item.content.label.default)),
                secondary: Object.assign({}, applyTokens(item.content.label.secondary)),
            },
        },
        MuiListSubheader: {
            styleOverrides: {
                root: Object.assign(Object.assign(Object.assign({}, applyTokens(sectioned.header)), applyTokens(sectioned.header.label)), { paddingTop: 0, ":not(:first-of-type)": {
                        marginTop: sectioned.gap.value,
                    } }),
                gutters: {
                    paddingLeft: item.plain.paddingLeft.value,
                    paddingRight: item.plain.paddingRight.value,
                },
            },
        },
    };
};
export default list;
//# sourceMappingURL=list.js.map